import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PAYMENT_METHODS_STATUSES, VEHICLE_STATUSES } from 'constants/index';
import BuyerDocsIcon from '../icons/buyer_docs.svg';
import ReportOfSaleIcon from '../icons/report_of_sale.svg';
import FundingNoteIcon from '../icons/funding_note.svg';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 24px;
`;

const DocItem = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #3994de1a;
  border-radius: 8px;
  padding: 16px;
  text-decoration: none;
  cursor: pointer;

  &:hover span {
    text-decoration: underline;
  }
`;

const DocItemLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #3994de1a;
  border-radius: 8px;
  padding: 16px;
  text-decoration: none;
  cursor: pointer;

  &:hover span {
    text-decoration: underline;
  }
`;

const DocLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #225a91;
  white-space: nowrap;
  text-align: center;
`;

interface DocumentsBlockProps {
  vehicle: any;
}

const DocumentsBlock = ({ vehicle }: DocumentsBlockProps) => {
  if (vehicle.status !== VEHICLE_STATUSES.AWARDED) {
    return null;
  }

  return (
    <Wrapper>
      <DocItemLink to={`/vehicles/${vehicle.id}/buyer-docs`}>
        <BuyerDocsIcon />
        <DocLabel>Buyer Docs</DocLabel>
      </DocItemLink>

      {vehicle.seller_report_of_sale && (
        <DocItem href={vehicle.seller_report_of_sale} target="_blank" rel="noopener noreferrer">
          <ReportOfSaleIcon />
          <DocLabel>Report of Sale</DocLabel>
        </DocItem>
      )}

      {vehicle.payment_status === PAYMENT_METHODS_STATUSES.APPROVED && (
        <DocItem href={`/vehicles/${vehicle.id}/funding-notice`} target="_blank" rel="noopener noreferrer">
          <FundingNoteIcon />
          <DocLabel>Funding Notice</DocLabel>
        </DocItem>
      )}
    </Wrapper>
  );
};

export default DocumentsBlock;
